import { render, staticRenderFns } from "./thead.vue?vue&type=template&id=a999ec28&scoped=true&"
import script from "./thead.vue?vue&type=script&lang=js&"
export * from "./thead.vue?vue&type=script&lang=js&"
import style0 from "./thead.vue?vue&type=style&index=0&id=a999ec28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a999ec28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a999ec28', component.options)
    } else {
      api.reload('a999ec28', component.options)
    }
    module.hot.accept("./thead.vue?vue&type=template&id=a999ec28&scoped=true&", function () {
      api.rerender('a999ec28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deals/thead.vue"
export default component.exports